// extracted by mini-css-extract-plugin
export default {"root":"QT4sXUpbE6tt9vIwZl_n","asterisk":"V5HXjBWkTR9NaBqD0Fyp"};